/**
 * Event CRUD — backed by /api/events.
 * Public fetchEvents / createEvent / updateEvent / deleteEvent match the
 * legacy WeddingContext names so callers don't need to change.
 */
import { useCrudCollection } from './useCrudCollection';

export function useEvents() {
  const crud = useCrudCollection({ basePath: 'events' });
  return {
    events: crud.items,
    setEvents: crud.setItems,
    fetchEvents: crud.fetch,
    createEvent: crud.create,
    updateEvent: crud.update,
    deleteEvent: crud.remove,
  };
}
